/**
 * 获取硬件驱动控制单元对象，即网页中创建的OCX对象名称，在调用以下接口之前，必须先调用此函数传入硬件驱动控制单元对象。
 获取成功后，可按接口文档定义的接口方法进行调用，如调用打开端口
 getDev().OpenDevice(DT_PINPAD,'','','');
 */

import { DEVICE_CODE } from './config'
import { APP_CONFIG } from './config'

export function getDev() {
    let devOperate = undefined;
    let explorer = navigator.userAgent;
    //IE浏览器
    if (explorer.indexOf("MSIE") >= 0 || explorer.indexOf("Windows") >= 0) {
        devOperate = window['DeviceMgr'];
    } else {
        //android下使用
        devOperate = window.jsDeviceCtrl;
    }

    return devOperate;
}

export function openDevice(deviceID, dllPath, szPort, szParam) {

    var result = 1;
    try {
        result = getDev().OpenDevice(deviceID, dllPath, szPort, szParam);

    } catch (e) {
        result = 2;
    }
    return result;
}

export function closeDevice(deviceID) {

    var result = 1;
    try {
        result = getDev().CloseDevice(deviceID);

    } catch (e) {
        result = 2;
    }
    return result;
}




export function getDeviceStatus(deviceID) {

    var result = 1;
    try {
        result = getDev().GetDeviceStatus(deviceID);

    } catch (e) {
        result = 2;
    }
    return result;
}

export function driverIsOpen(deviceID) {

    var result = 1;
    try {
        result = getDev().DriverIsOpen(deviceID);

    } catch (e) {
        result = 2;
    }
    return result;
}

export function setDeviceLogFile(deviceID, logLevel, filePath) {

    var result = 1;
    try {
        result = getDev().SetDeviceLogFile(deviceID, logLevel, filePath);

    } catch (e) {
        result = 2;
    }
    return result;
}

export function getDevSn() {
    try {
        return "TL_MY_01";
        return getDev().GetHDSN();

    } catch (e) {
        return "TL_MY_01";
    }
}

export function getLastMsg() {

    var result = 1;
    try {
        result = getDev().GetLastMsg();

    } catch (e) {
        result = 2;
    }
    return result;
}


export function getLastCode() {

    return getDev().GetLastCode();
}


export function getStatusMsg() {

    return getDev().GetLastMsg();
}

/**
 * md5加密
 * @param val
 * @returns {*}
 */
export function tlMd5(val) {

    try {
        return getDev().GetMD5(val);
    } catch (e) {
        return "";
    }


}


/**
 * des加密
 * @param val
 * @returns {*}
 * @constructor
 */
export function JSDESEncrypt(val) {
    return getDev().JSDESEncrypt(val);
}

/**
 * des解密
 * @param val
 * @returns {*}
 * @constructor
 */
export function JSDESDecrypt(val) {
    return getDev().JSDESDecrypt(val);
}

/**
 * rsa设置公钥
 * @param val
 * @returns {*}
 * @constructor
 */
export function RSASetPublickey(val) {
    return getDev().RSASetPublickey(val);
}


/**
 * rsa公钥解密
 * @param val
 * @returns {*}
 * @constructor
 */
export function RSAPublicDecrypt(val) {
    // RSASetPublickey(global.LOCAL_DATA.devInfo.rsaPublicKey);
    return getDev().RSAPublicDecrypt(val);
}

/**
 * 公钥加密
 * @param val
 * @returns {*}
 * @constructor
 */
export function RSAPublicEncrypt(val) {
    return getDev().RSAPublicEncrypt(val);
}


/**
 * 1重启 2关机 3休眠,10表示退到桌面，11表示清理缓存 12表示清理垃圾
 * @param val
 * @constructor
 */
export function SystemCtrl(val) {
    return getDev().SystemCtrl(val);
}

export function getDevName(devCode) {

    var devName = "";
    switch (devCode) {
        case DEVICE_CODE.DT_RPRN:
            devName = "清单打印机";
            break;
        case DEVICE_CODE.DT_CASH:
            devName = "纸币识别器";
            break;
        case DEVICE_CODE.DT_SCREADER:
            devName = "读卡器";
            break;
        case DEVICE_CODE.DR_NETWORK:
            devName = "网络组件";
            break;
        case DEVICE_CODE.DT_DRVID:
            devName = "发卡器";
            break;

    }

    return devName;
}

export function RPPrintText(DEVID, szText, szStyle) {
    return getDev().RPPrintText(DEVID, szText, szStyle);
}

export function RPCutPaper(DEVID) {
    RPPrintText(DEVID, "\n\n", ""); //切纸离打印内容需走纸一定距离
    return getDev().RPCutPaper(DEVID, 0);
}

export function RPPrintLOGO(DEVID, idx) {
    return getDev().RPPrintLOGO(DEVID, idx);
}

//打印条形码
/*
 szData :条码内容
 hasText:0条码上下方不打印内容文字，1条码下方打印文字，2条码上方打印文字
 */
export function RPPrintBarCode(szData, hasText) {
    //73 为条码类型CODE128 ; 90为条码高度； 2为条码间隔
    return getDev().RPPrintBarCode(DEVICE_CODE.DT_RPRN, szData, 73, 90, 2, hasText);
}

export function writeAppLog(logLevel, msg) {
    var str = "";
    switch (logLevel) {
        case 1:
            str = "异常";
            break;
        case 2:
            str = "错误";
            break;
        case 3:
            str = "警告";
            break;
        case 4:
            str = "信息";
            break;
        case 5:
            str = "调试";
            break;
        case 6:
            str = "同步";
            break;
        default:
            str = "其它";
    }
    try {
        let dt = new Date();
        let system = getDev().GetSystemEnv("SYSTEM");
        let splitStr = "\\";
        if (system == "Android")
            splitStr = "/";
        let LogPath = getDev().GetSystemEnv("LOGPATH");
        if (logLevel == 6) {
            LogPath = LogPath + dt.format('yyyyMM') + splitStr + dt.format('yyyyMMdd') + splitStr + 'Sync_' + dt.format('yyyyMMdd') + '.log';

        } else {
            LogPath = LogPath + dt.format('yyyyMM') + splitStr + dt.format('yyyyMMdd') + splitStr + 'Run_' + dt.format('yyyyMMdd') + '.log';

        }
        getDev().WriteTextFile(LogPath, dt.format("hh:mm:ss") + "\t" + str + "\t" + msg);
        if (logLevel <= 2) {
            LogPath = getDev().GetSystemEnv("LOGPATH") + dt.format('yyyyMM') + splitStr + dt.format('yyyyMMdd') + splitStr + 'Err_' + dt.format('yyyyMM') + '.log';
            getDev().WriteTextFile(LogPath, dt.format("yyyy-MM-dd hh:mm:ss") + "\t" + str + "\t" + msg);
        }
    } catch (e) {;
    }

}


// WEBPACK FOOTER //
// ./src/assets/js/deviceOperate.js